document.addEventListener('DOMContentLoaded', () => {
    _ta['We work from :time_start to :time_end'] = 'Работаем c :time_start до :time_end';
    _ta['We work around the clock'] = 'Работаем круглосуточно';

    let info_window = null,
        lat_lng_bounds = null,
        map = null

    new ObserverConstructor('#js_contact-map', {}, (entries, observer) => {
        entries.forEach(entry => {
            if (!entry.isIntersecting) return;

            let el = entry.target;

            observer.unobserve(el);

            let script = document.createElement('script');

            script.src = '//maps.googleapis.com/maps/api/js?key=' + g_params.google_api_key + '&language=' + g_params.lang;
            script.onload = initialize;

            document.head.appendChild(script);
        });
    });

    function initialize() {
        let el_contact_map = document.getElementById('js_contact-map');

        if (!el_contact_map) return;

        let lat = el_contact_map.dataset.lat || 55.007542,
            lon = el_contact_map.dataset.lon || 82.878920;

        map = new google.maps.Map(document.getElementById('js_contact-map'), {
            center: new google.maps.LatLng(lat, lon),
            zoom: parseInt(el_contact_map.dataset.zoom),
            styles: [
                {
                    "elementType": "geometry",
                    "stylers": [{"color": "#f2f2f3"}]
                },
                {
                    "elementType": "labels.icon",
                    "stylers": [{"saturation": -100}]
                },
                {
                    "elementType": "labels.text.fill",
                    "stylers": [{"color": "#bab9bf"}]
                },
                {
                    "elementType": "labels.text.stroke",
                    "stylers": [{"color": "#а6а6а6"}]
                },
                {
                    "featureType": "administrative.land_parcel",
                    "elementType": "labels.text.fill",
                    "stylers": [{"color": "#bdbdbd"}]
                },
                {
                    "featureType": "poi",
                    "elementType": "geometry",
                    "stylers": [{"color": "#eeeeee"}]
                },
                {
                    "featureType": "poi",
                    "elementType": "labels.text.fill",
                    "stylers": [{"color": "#757575"}]
                },
                {
                    "featureType": "poi.park",
                    "elementType": "geometry",
                    "stylers": [{"color": "#e5e5e5"}]
                },
                {
                    "featureType": "poi.park",
                    "elementType": "labels.text.fill",
                    "stylers": [{"color": "#9e9e9e"}]
                },
                {
                    "featureType": "road",
                    "elementType": "geometry",
                    "stylers": [{"color": "#ffffff"}]
                },
                {
                    "featureType": "road",
                    "elementType": "labels.icon",
                    "stylers": [{"visibility": "off"}]
                },
                {
                    "featureType": "road.arterial",
                    "elementType": "labels.text.fill",
                    "stylers": [{"color": "#757575"}]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "geometry",
                    "stylers": [{"color": "#dadada"}]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "labels.text.fill",
                    "stylers": [{"color": "#616161"}]
                },
                {
                    "featureType": "road.local",
                    "elementType": "labels.text.fill",
                    "stylers": [{"color": "#9e9e9e"}]
                },
                {
                    "featureType": "transit.line",
                    "elementType": "geometry",
                    "stylers": [{"color": "#e5e5e5"}]
                },
                {
                    "featureType": "transit.station",
                    "elementType": "geometry",
                    "stylers": [{"color": "#eeeeee"}]
                },
                {
                    "featureType": "water",
                    "elementType": "geometry",
                    "stylers": [{"color": "#eaeaeb"}]
                },
                {
                    "featureType": "water",
                    "elementType": "labels.text.fill",
                    "stylers": [{"color": "#9e9e9e"}]
                }
            ]
        });
        info_window = new google.maps.InfoWindow();
        lat_lng_bounds = new google.maps.LatLngBounds();

        get_partners(data => {
            if (!data.partners) return;

            set_markers(map, lat_lng_bounds, info_window, data.partners);

            function set_markers(map, lat_lng_bounds, info_window, data = []) {
                data.forEach(item => {
                    lat_lng_bounds.extend(new google.maps.LatLng(item.lat, item.lon));

                    let marker = new google.maps.Marker({
                        animation: google.maps.Animation.DROP,
                        icon: {
                            path: google.maps.SymbolPath.CIRCLE,
                            scale: 6,
                            fillColor: '#d93c82',
                            fillOpacity: 1,
                            strokeColor: 'rgba(216, 60, 130, .2)',
                            strokeWeight: 10,
                        },
                        map,
                        position: new google.maps.LatLng(item.lat, item.lon),
                    });

                    marker.addListener('click', () => {
                        let work_time = _t('We work from :time_start to :time_end')
                            .replace(':time_start', item.work_start)
                            .replace(':time_end', item.work_end);

                        if (item.work_start === '0:00' && item.work_end === '24:00' || item.work_start === item.work_end) {
                            work_time = _t('We work around the clock');
                        }

                        info_window.close();
                        info_window.setContent('' +
                            '<div style="height: auto; width: auto; white-space: nowrap;">' +
                            '<p>' +
                            '<img src="/images/theme/marker.png" width="15px" height="20px" style="margin: 0 12px 0 1px;" alt="">' + item.address +
                            '</p>' +
                            '<p style="line-height: 33px">' +
                            '<i class="i-clock mr-1"></i> ' + work_time +
                            '</p>' +
                            '<img src="/images/theme/phone.svg" width="15" height="18" style="margin: 0 7px 0 1px;" alt=""> <b>' + item.phone + '</b>' +
                            '</div>');
                        info_window.open(map, marker);
                    });
                });

                if (data.length > 1)
                    map.fitBounds(lat_lng_bounds);
                else
                    map.setCenter(new google.maps.LatLng(data[0].lat, data[0].lon));
            }
        });

        function get_partners(callback) {
            fetch(g_params.url_prefix + '/client-api/map-city')
                .then(res => res.json())
                .then(data => {
                    if (callback && typeof callback === 'function')
                        callback(data);
                });
        }
    }
});
